import { mainSplitApi } from "./mainSplitApi";
import { AgencyQueryServices } from "./services/agency/agency.qrtk";
import { DownloadQueryServices } from "./services/download/download.qrtk";
import { GeoLocationQueryServices } from "./services/geoLocation/geoLocation.qrtk";
import { OwnersQueryServices } from "./services/owners/owners.qrtk";
import { RealEstateQueryServices } from "./services/realestate/realestate.qrtk";

interface IStoreQRTK {
  reducer: {};
  middleware: any[];
}
export const storeRFC_QRTK: IStoreQRTK = {
  reducer: {
    [mainSplitApi.reducerPath]: mainSplitApi.reducer,
    [GeoLocationQueryServices.reducerPath]:
      GeoLocationQueryServices.reducer,
    [RealEstateQueryServices.reducerPath]: RealEstateQueryServices.reducer,
    [AgencyQueryServices.reducerPath]: AgencyQueryServices.reducer,
    [DownloadQueryServices.reducerPath]: DownloadQueryServices.reducer,
    [OwnersQueryServices.reducerPath]: OwnersQueryServices.reducer
  },
  middleware: [
    GeoLocationQueryServices.middleware,
    RealEstateQueryServices.middleware,
    AgencyQueryServices.middleware,
    DownloadQueryServices.middleware,
    OwnersQueryServices.middleware,
    mainSplitApi.middleware
  ]
};
